import { devicesTypes } from "../actions/devices";
import { authTypes } from "../actions/auth";

const initialState = {
  isLoading: false,
  isDownloaded: "",
   ui: {
    notification: {
      isActive: false,
      type: "success",
      message: "",
      description: "",
      style: { backgroundColor: "#d4edda", color: "#155724" },
    },
    formData: {
        errors: {
          deviceType: false,
          major: false,
          minor: false,
          serialNumber: false,
          macAddress: false,
        },
        isOpen: false,
        deviceTypes: [],
        deviceType: "",
        major: "",
        minor: "",
        serialNumber: "",
        macAddress: "",
    },
  },
  filters: {
    isLoaded: false,
    healthStatus: "",
    deviceConnectedStatus: "",
    deviceName: "",
    shipmentname: "",
    deviceType: [],
    activeStatus: "",
    organization: "",
    location: "",
    sort: [
      {
        field: "createdon",
        order: "desc",
      },
    ],
    pagenumber: 0,
    limitnumber: 50,
  },
  data: {
    healthStatusList: [
      // {
      //   label: "All",
      //   value: false,
      // },
      {
        label: "Ok",
        value: false,
      },
      {
        label: "Warning",
        value: false,
      },
      {
        label: "Critical",
        value: false,
      },
      {
        label: "Unknown",
        value: false,
      },
      {
        label: "Notification",
        value: false,
      },
    ],
    deviceConnectedStatusList: [
      // {
      //   label: "All",
      //   value: false,
      // },
      {
        label: "Online",
        value: false,
      },
      {
        label: "Offline",
        value: false,
      },
      {
        label: "Unknown",
        value: false,
      },
    ],
    deviceType: [
      // {
      //   label: "All",
      //   value: "",
      // },
      {
        label: "Gateway",
        value: "ts.device.tgAssetTracker",
      },
      {
        label: "BLE Tag",
        value: "ts.device.ble",
      },
    ],
    activeStatusList: [
      // {
      //   label: "All",
      //   value: "",
      // },
      {
        label: "Active",
        value: "ACTIVE",
      },
      {
        label: "Inactive",
        value: "INACTIVE",
      },
    ],
    devices: [],
    locations: [],
    isFiltered: false,
    organizations: [],
  },
  deviceCounts: {
    total: 0,
    online: 0,
    offline: 0,
    warning: 0,
    error: 0,
  },
  error: null,
};

const devicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case devicesTypes.FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case devicesTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          ...action.payload,
        },
        filters: {
          ...state.filters,
          isLoaded: true,
        },
        error: null,
      };
    case devicesTypes.UPDATE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
          sort: action.payload.sort,
        },
      };
    case devicesTypes.DEVICE_COUNT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        deviceCounts: action.payload,
      };
    case devicesTypes.FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        data: {
          ...state.data,
          alarms: [],
        },
        deviceCounts: {
          total: 0,
          online: 0,
          offline: 0,
          warning: 0,
          error: 0,
        },
        error: action.payload,
      };
    case devicesTypes.DOWNLOAD_REQUEST:
      return {
        ...state,
        isDownloaded: "Downloading....",
      };
    case devicesTypes.DOWNLOAD_SUCCESS:
      return {
        ...state,
        isDownloaded: "Downloaded",
      };
    case devicesTypes.DOWNLOAD_FAILURE:
      return {
        ...state,
        isDownloaded: "Something Went Wrong",
        error: action.payload,
      };
      case devicesTypes.FETCH_DEVICE_TYPES_REQUEST: {
            return {
              ...state,
              isLoading: true,
            };
          }
          case devicesTypes.FETCH_DEVICE_TYPES_SUCCESS: {
            return {
              ...state,
              isLoading: false,
              ui: {
                ...state.ui,
                formData: {
                  ...state.ui.formData,
                  
                    deviceTypes: action.payload,
                },
              },
              error: null,
            };
          }
          case devicesTypes.FETCH_DEVICE_TYPES_FAILURE: {
            return {
              ...state,
              isLoading: false,
              error: action.payload,
              ui: {
                ...state.ui,
                formData: {
                  ...state.ui.formData,               
                    deviceTypes: [],
                },
              },
            };
          }
          case devicesTypes.UPDATE_UI:
            console.log("action.payload", action.payload);
            return {
              ...state,
              ui: {
                ...state.ui,
                  notification: {
                            isActive: false,
                            type: "success",
                            message: "Create",
                            description: "Device created successfully",
                            style: { backgroundColor: "#d4edda", color: "#155724" },
                          },
                formData: {
                  ...state.ui.formData,
                   ...(action.payload.formData || {}),
                          },
                        },
                      }
                case devicesTypes.CREATE_REQUEST:
                      return {
                        ...state,
                        ui: {
                          ...state.ui,
                            notification: {
                            isActive: false,
                            type: "success",
                            message: "Create",
                            description: "Device created successfully",
                            style: { backgroundColor: "#d4edda", color: "#155724" },
                          },
                          formData: {
                            ...state.ui.formData,
                            isSubmitted: true,
                          },
                        },
                      }
                    case devicesTypes.CREATE_SUCCESS:
                      return {
                        ...state,
                        // isRefresh: !state.isRefresh,
                        ui: {
                          ...state.ui,
                          notification: {
                            isActive: true,
                            type: "success",
                            message: "Create",
                            description: "Device created successfully",
                            style: { backgroundColor: "#d4edda", color: "#155724" },
                          },
                         formData: {
        errors: {
          deviceType: false,
          major: false,
          minor: false,
          serialNumber: false,
          macAddress: false,
        },
        isOpen: false,
        deviceTypes: [],
        deviceType: "",
        major: "",
        minor: "",
        serialNumber: "",
        macAddress: "",
    },
                          isOpen: false,
                        },
                      };
                    case devicesTypes.CREATE_FAILURE:
                      return {
                        ...state,
                        error: action.payload,
                        ui: {
                          ...state.ui,
                          notification: {
                            isActive: true,
                            type: "error",
                            message: "Create",
                            description: "Failed to create device",
                            style: { backgroundColor: "#f8d7da", color: "#721c24" },
                          },
                          formData: {
        errors: {
          deviceType: false,
          major: false,
          minor: false,
          serialNumber: false,
          macAddress: false,
        },
        isOpen: false,
        deviceTypes: [],
        deviceType: "",
        major: "",
        minor: "",
        serialNumber: "",
        macAddress: "",
    },
                          isOpen: false,
                        },
                      };
    case devicesTypes.CLEAR_FILTER:
      return {
        ...state,
        filters: {
          isLoaded: false,
          healthStatus: "",
          deviceConnectedStatus: "",
          deviceName: "",
          shipmentname: "",
          deviceType: [],
          activeStatus: "",
          organization: "",
          location: "",
          sort: [
            {
              field: "createdon",
              order: "desc",
            },
          ],
          pagenumber: 0,
          limitnumber: 50,
        },
        data: {
          ...state.data,
          healthStatusList: [
            {
              label: "Ok",
              value: false,
            },
            {
              label: "Warning",
              value: false,
            },
            {
              label: "Critical",
              value: false,
            },
            {
              label: "Unknown",
              value: false,
            },
            {
              label: "Notification",
              value: false,
            },
          ],
          deviceConnectedStatusList: [
            {
              label: "Online",
              value: false,
            },
            {
              label: "Offline",
              value: false,
            },
            {
              label: "Unknown",
              value: false,
            },
          ],
          deviceType: [
            {
              label: "Gateway",
              value: "ts.device.tgAssetTracker",
            },
            {
              label: "BLE Tag",
              value: "ts.device.ble",
            },
          ],
          activeStatusList: [
            {
              label: "Active",
              value: "ACTIVE",
            },
            {
              label: "Inactive",
              value: "INACTIVE",
            },
          ],
        },
      };
    case authTypes.LOGOUT:
    case authTypes.AUTO_LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default devicesReducer;